"use client";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { IconBookOpen, IconChats, IconDiscord, type IconProps } from "@teral/icons";
import type { Route } from "next";
import { useRouter } from "next/navigation";
import React from "react";
import { useFeedback } from "./feedback-component";

export function CommandMenu() {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);
  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Type a command or search..." />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>

        <CommandGroup heading="Help">
          <DiscordCommand />
          <GenericLinkCommand
            close={() => setOpen(false)}
            href="https://docs.teral.dev/"
            label="Documentation"
            icon={IconBookOpen}
          />
          <FeedbackCommand />
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}

const DiscordCommand: React.FC = () => {
  const router = useRouter();
  return (
    <CommandItem onSelect={() => router.push("https://teral.dev/discord")}>
      <IconDiscord className="mr-2 size-4" />
      <span>Go to Discord</span>
    </CommandItem>
  );
};

const GenericLinkCommand: React.FC<{
  href: string;
  label: string;
  icon: React.FC<IconProps>;
  close: () => void;
}> = (props) => {
  const router = useRouter();
  return (
    <CommandItem
      onSelect={() => {
        router.push(props.href as Route);
        props.close();
      }}
    >
      <props.icon className="w-4 h-4 mr-2" />
      <span>{props.label}</span>
    </CommandItem>
  );
};

const FeedbackCommand: React.FC = () => {
  const { openFeedback } = useFeedback();

  return (
    <CommandItem onSelect={() => openFeedback(true)}>
      <IconChats className="size-4 mr-2" />
      <span>Feedback</span>
    </CommandItem>
  );
};
